import { EntityRepository, Repository } from "typeorm";
import { MachinesRequisitionSnapEntity } from "../entity/machine-requisition-snap-entity";


@EntityRepository(MachinesRequisitionSnapEntity)
export class MachinesRequisitionSnapRepo extends Repository<MachinesRequisitionSnapEntity>{

}
